import { apiClient } from '../apiClient';
import { PackagesResponse, PackagesQueryParams } from '../../types/package';

class PackagesService {
    async getPackages(params: PackagesQueryParams): Promise<PackagesResponse> {
        // Create a new object to store only the parameters that have values
        const queryParams: Record<string, any> = {
            per_page: params.per_page || 20,
        };

        // Only add page if it's provided and greater than 0
        if (params.page && params.page > 0) {
            queryParams.page = params.page;
        }

        // Add status only if it's not empty string
        if (params.status !== undefined && params.status !== '') {
            queryParams.status = params.status;
        }

        // Add school_id only if it's a number (not empty string)
        if (params.school_id !== undefined && params.school_id !== '') {
            queryParams.school_id = params.school_id;
        }

        // Only add date range parameters if both start and end dates are provided
        if (params.date_range?.start && params.date_range?.end) {
            queryParams['date_range[start]'] = params.date_range.start;
            queryParams['date_range[end]'] = params.date_range.end;
        }
        
        const response = await apiClient.get<PackagesResponse>('/api/v1/admin/packages', { 
            params: queryParams 
        });
        return response.data;
    }
}

export const packagesService = new PackagesService(); 